// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import ChangeTabsController from "./change_tabs_controller"
application.register("change-tabs", ChangeTabsController)

import CheckAllController from "./check_all_controller"
application.register("check-all", CheckAllController)

import CheckCountController from "./check_count_controller"
application.register("check-count", CheckCountController)

import ClickLinkController from "./click_link_controller"
application.register("click-link", ClickLinkController)

import CurrencyController from "./currency_controller"
application.register("currency", CurrencyController)

import FuncionamentoController from "./funcionamento_controller"
application.register("funcionamento", FuncionamentoController)

import MaskController from "./mask_controller"
application.register("mask", MaskController)

import MensagemFormController from "./mensagem_form_controller"
application.register("mensagem-form", MensagemFormController)

import Modal__ShowController from "./modal/show_controller"
application.register("modal--show", Modal__ShowController)

import PeriodosController from "./periodos_controller"
application.register("periodos", PeriodosController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import TogglerController from "./toggler_controller"
application.register("toggler", TogglerController)

import Ts__FilterController from "./ts/filter_controller"
application.register("ts--filter", Ts__FilterController)

import Ts__SearchController from "./ts/search_controller"
application.register("ts--search", Ts__SearchController)

import Ts__SelectController from "./ts/select_controller"
application.register("ts--select", Ts__SelectController)

import TtipController from "./ttip_controller"
application.register("ttip", TtipController)
